module.exports = __webpack_public_path__ + "static/media/icono-info.eb6b5948.svg";